import React from 'react';
import Card from '../../ui/Card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const MonthlySpendTrend: React.FC = () => {
  const data = [{
    month: 'Jan',
    atl: 6.8,
    btl: 5.2,
    digital: 7.5,
    trade: 3.8
  }, {
    month: 'Feb',
    atl: 7.2,
    btl: 5.5,
    digital: 7.8,
    trade: 4.0
  }, {
    month: 'Mar',
    atl: 7.5,
    btl: 5.8,
    digital: 8.2,
    trade: 4.2
  }, {
    month: 'Apr',
    atl: 6.5,
    btl: 5.0,
    digital: 7.2,
    trade: 3.5
  }, {
    month: 'May',
    atl: 7.0,
    btl: 5.4,
    digital: 7.9,
    trade: 4.1
  }, {
    month: 'Jun',
    atl: 7.8,
    btl: 6.0,
    digital: 8.5,
    trade: 4.5
  }, {
    month: 'Jul',
    atl: 7.2,
    btl: 5.6,
    digital: 8.0,
    trade: 4.2
  }, {
    month: 'Aug',
    atl: 7.5,
    btl: 5.9,
    digital: 8.3,
    trade: 4.4
  }, {
    month: 'Sep',
    atl: 6.9,
    btl: 5.3,
    digital: 7.7,
    trade: 3.9
  }, {
    month: 'Oct',
    atl: 7.4,
    btl: 5.7,
    digital: 8.4,
    trade: 4.3
  }, {
    month: 'Nov',
    atl: 7.8,
    btl: 6.1,
    digital: 8.7,
    trade: 4.6
  }, {
    month: 'Dec',
    atl: 8.2,
    btl: 6.4,
    digital: 9.0,
    trade: 4.8
  }];
  return <Card className="p-6" data-id="element-7838">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-7839">
        Month-wise Spend Trend
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-7840">
        Channel spending over time (₹ Cr)
      </p>
      <ResponsiveContainer width="100%" height={300} data-id="element-7841">
        <LineChart data={data} data-id="element-7842">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-7843" />
          <XAxis dataKey="month" tick={{
          fontSize: 12
        }} data-id="element-7844" />
          <YAxis tick={{
          fontSize: 12
        }} data-id="element-7845" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number) => `₹${value} Cr`} data-id="element-7846" />
          <Legend data-id="element-7847" />
          <Line type="monotone" dataKey="atl" stroke="#3b82f6" strokeWidth={2} name="ATL" dot={{
          r: 3
        }} data-id="element-7848" />
          <Line type="monotone" dataKey="btl" stroke="#10b981" strokeWidth={2} name="BTL" dot={{
          r: 3
        }} data-id="element-7849" />
          <Line type="monotone" dataKey="digital" stroke="#f59e0b" strokeWidth={2} name="Digital" dot={{
          r: 3
        }} data-id="element-7850" />
          <Line type="monotone" dataKey="trade" stroke="#8b5cf6" strokeWidth={2} name="Trade" dot={{
          r: 3
        }} data-id="element-7851" />
        </LineChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7852">
        <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-7853">
          <div className="flex justify-between" data-id="element-7854">
            <span className="text-gray-600" data-id="element-7855">Q4 Total</span>
            <span className="font-semibold text-gray-900" data-id="element-7856">₹91.8 Cr</span>
          </div>
          <div className="flex justify-between" data-id="element-7857">
            <span className="text-gray-600" data-id="element-7858">Growth vs Q3</span>
            <span className="font-semibold text-green-600" data-id="element-7859">+12.4%</span>
          </div>
        </div>
      </div>
    </Card>;
};
export default MonthlySpendTrend;